module.exports = __webpack_public_path__ + "kw.svg?e36d4852502b13f188c96dd8ffa8db8b";